<template>
	<div id="contact">
		<AmeliproCard
			card-title="Organisme local d'Assurance Maladie"
			class="my-custom-margin"
		>
			<v-list>
				<v-list-item>
					<v-list-item-content>
						<v-list-item-title>Organisme</v-list-item-title>
						<v-list-item-subtitle>
							{{ organisme.libelleComplet }}
						</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

				<v-list-item v-if="organisme.prenomDirecteur && organisme.nomDirecteur">
					<v-list-item-content>
						<v-list-item-title>Directeur</v-list-item-title>
						<v-list-item-subtitle>
							{{ organisme.prenomDirecteur + ' ' + organisme.nomDirecteur }}
						</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

				<v-list-item v-if="organisme.adresse">
					<v-list-item-content>
						<v-list-item-title>Adresse postale</v-list-item-title>
						<v-list-item-subtitle>
							{{ organisme.adresse.adresseLibelle }}
						</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					v-if="
						organisme.contactOrganismes && organisme.contactOrganismes.length
					"
				>
					<v-list-item-content>
						<v-list-item-title>Contact(s)</v-list-item-title>
						<v-list-item-subtitle>
							<v-list>
								<v-list-item
									v-for="(contact, index) in filteredContactOrganismes"
									:key="index"
								>
									<v-list-item-content>
										<v-list-item-title>{{ contact.libelle }}</v-list-item-title>
										<v-list-item-subtitle>
											Téléphone : {{ contact.telephone }}
										</v-list-item-subtitle>
										<v-list-item-subtitle>
											E-mail : {{ contact.mail }}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</AmeliproCard>

		<div v-if="0 < autoritesFiltered.length">
			<AmeliproCard
				v-for="(autorite, index) in autoritesFiltered"
				:key="index"
				:card-title="autorite.typelibelle"
				class="my-custom-margin"
			>
				<v-list>
					<v-list-item>
						<v-list-item-content>
							<v-list-item-title>Organisme</v-list-item-title>
							<v-list-item-subtitle>{{ autorite.nom }}</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content>
							<v-list-item-title>Directeur</v-list-item-title>
							<v-list-item-subtitle>
								{{ autorite.directeur }}
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content>
							<v-list-item-title>Contact</v-list-item-title>
							<v-list-item-subtitle>
								{{ autorite.contact }}
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content>
							<v-list-item-title>Adresse postale</v-list-item-title>
							<v-list-item-subtitle>
								{{ autorite.adresse }}
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content>
							<v-list-item-title>Numéro de téléphone</v-list-item-title>
							<v-list-item-subtitle>
								{{ autorite.telephone }}
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content>
							<v-list-item-title>E-mail</v-list-item-title>
							<v-list-item-subtitle>{{ autorite.mail }}</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</AmeliproCard>
		</div>
	</div>
</template>

<script lang="ts">
	import Component, { mixins } from 'vue-class-component';
	import { Meta, MetaInfo } from '@/decorators';
	import UserMixin from '@/mixins/userMixin';
	import { Organisme } from '@/services/api/types';
	import { TYPE_AUTORITE } from '@/services/constantes';
	import { ContactOrganisme } from '@/services/api/types';
	const MixinsDeclaration = mixins(UserMixin);
	@Component<InfoContact>({
		created() {
			if (this.utilisateurExterneInfo && this.utilisateurExterneInfo.organisme) {
				this.organisme = this.utilisateurExterneInfo.organisme;
			}
		},
		computed: {
			autoritesFiltered() {
				return this.utilisateurExterneInfo.organisme.autorites.filter(
					(autorite) => {
						if (this.utilisateurExterneInfo.isDocteur) {
							return (
								autorite.type === TYPE_AUTORITE.CONSEIL_ORDRE ||
								autorite.type === TYPE_AUTORITE.ARS
							);
						} else if (this.utilisateurExterneInfo.isStructure) {
							return autorite.type === TYPE_AUTORITE.SYNDICAT;
						}
						return false;
					}
				);
			},

			filteredContactOrganismes(): ContactOrganisme[] {
				if (!this.organisme || !this.organisme.contactOrganismes) {
					return [];
				}

				const userType = this.utilisateurExterneInfo.isDocteur ? '2' : '1';

				// Vérifier si contactOrganismes est un tableau avant d'utiliser filter
				if (Array.isArray(this.organisme.contactOrganismes)) {
					return this.organisme.contactOrganismes.filter(
						(contact: ContactOrganisme) =>
							contact.types && contact.types.includes(userType)
					);
				} else {
					// Si ce n'est pas un tableau, retourner un tableau vide
					return [];
				}
			}
		}
	})
	export default class InfoContact extends MixinsDeclaration {
		/* istanbul ignore next */
		@Meta
		metaInfo(): MetaInfo {
			return {
				title: 'PEGASE - Contacts' as string
			};
		}
		organisme: Organisme | null = null;
	}
</script>
